module.exports = __webpack_public_path__ + "static/media/u-value.887f5056.png";